import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './toast';
import { useTranslation } from 'react-i18next';
import { useToast } from './use-toast';

export function Toaster() {
  const { toasts } = useToast();
  // #2424: Radix's English defaults reached screen readers in every language.
  // `label` prefixes each live-region announcement; `viewportLabel` names the
  // region landmark, and Radix substitutes its own `{hotkey}` token (single
  // braces, so i18next leaves it alone — translations must keep it verbatim).
  const { t } = useTranslation('common');

  return (
    <ToastProvider label={t('toast.label')}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          // 5 s, or 7 s for a destructive toast. Radix pauses the timer while
          // the window is blurred or hidden and while the pointer or focus is
          // on the viewport, so a toast in a background tab outlives these
          // numbers by design (#2398: the 10-minute toasts were a hidden tab).
          <Toast key={id} {...props} duration={props.variant === 'destructive' ? 7000 : 5000}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport label={t('toast.viewportLabel')} />
    </ToastProvider>
  );
}
